/**
 * Created by Carry on May/29/18.
 */
import FJCoreConfig from '../FJCoreConfig';
import $ from 'jquery';
import FJMathUtil from '../../util/FJMathUtil';
import FJArchiveUtil from '../../util/FJArchiveUtil';

const FixNode = {
    FixedNode_LEFT_TOP: 'FixedNode_LEFT_TOP',
    FixedNode_RIGHT_TOP: 'FixedNode_RIGHT_TOP',
    FixedNode_RIGHT_BOTTOM: 'FixedNode_RIGHT_BOTTOM',
    FixedNode_LEFT_BOTTOM: 'FixedNode_LEFT_BOTTOM',
};

const TrackNode = {
    NONE: -1,
    LEFT_TOP: 0,
    TOP: 1,
    RIGHT_TOP: 2,
    RIGHT: 3,
    RIGHT_BOTTOM: 4,
    BOTTOM: 5,
    LEFT_BOTTOM: 6,
    LEFT: 7,
    ROTATE: 8,
    MOVE: 9,
};
class FJTrack {
    _trackLayer;
    _nodes;
    _hasNode = true;
    _hasResizeNode = true;
    _hasRotationNode = false;
    _keepAspectRatio = true;
    _trackRect;
    _angle = 0;
    _trackNodeRadius = 7;
    _trackNodeBoxShadow = '0px 0px 5px 0px rgba(0, 0, 0, 0.35)';
    _rotateNodeRadius = 11;
    _rotateLength = 12;
    _rotateSVG;
    _selectedNode = -1;
    _selected = false;
    // 旋转点位置自动适配
    _hasRotateAutoAdapt = true;
    _lineView;
    _nodeView;

    _lineColor = 'rgba(50, 231, 255, 1)'; // "rgba(255, 255, 255, 0.5)"
    _lineWidth = 4;

    _lineBackColor = 'rgba(0, 0, 0, 0.85)'; // "rgba(0, 0, 0, 0.4)"

    _viewRect; // 画布区域
    _owner = null;

    constructor(props) {
        if (props) {
            if (typeof props.owner !== 'undefined') this._owner = props.owner;
            if (typeof props.lineColor !== 'undefined') this._lineColor = props.lineColor;
            if (typeof props.lineBackColor !== 'undefined') this._lineBackColor = props.lineBackColor;
            if (typeof props.lineWidth !== 'undefined') this._lineWidth = props.lineWidth;
            if (typeof props.hasNode !== 'undefined') this._hasNode = props.hasNode;
            if (typeof props.hasResizeNode !== 'undefined') this._hasResizeNode = props.hasResizeNode;

            // keepAspectRatio 指的是是否支持缩放的交互，即 true 时不支持上下左右的 bar 交互
            // 处于兼容性的考虑，新增 keepAspectVertical 和 keepAspectHorizontal 用于是垂直/水平方向的 bar 的控制
            // keepAspectRatio 的优先级高于 keepAspectVertical 和 keepAspectHorizontal
            // 如果 keepAspectVertical 和 keepAspectHorizontal 都为 true 的话建议将 keepAspectRatio 设置为 true
            if (typeof props.keepAspectRatio !== 'undefined') this._keepAspectRatio = props.keepAspectRatio;
            if (typeof props.keepAspectVertical !== 'undefined') this._keepAspectVertical = props.keepAspectVertical;
            if (typeof props.keepAspectHorizontal !== 'undefined')
                this._keepAspectHorizontal = props.keepAspectHorizontal;

            if (typeof props.hasRotationNode !== 'undefined') this._hasRotationNode = props.hasRotationNode;
            if (typeof props.trackNodeRadius !== 'undefined') this._trackNodeRadius = props.trackNodeRadius;
            if (typeof props.rotateNodeRadius !== 'undefined') this._rotateNodeRadius = props.rotateNodeRadius;
            if (typeof props.rotateLength !== 'undefined') this._rotateLength = props.rotateLength;
            if (typeof props.trackNodeBoxShadow !== 'undefined') this._trackNodeBoxShadow = props.trackNodeBoxShadow;
        }
    }

    _init() {
        if (this._trackLayer) {
            return;
        }
        this._nodes = [];
        this._nodeView = [];
        this._initTrackLayer();
        this._initWireframe();
        this._initNodesView();
        this._initRotateSVG();
    }

    _initTrackLayer() {
        this._trackLayer = document.createElement('div');
        this._trackLayer.style.position = 'absolute';
        this._trackLayer.style.backfaceVisibility = 'hidden';
    }
    _initWireframe() {
        this._lineView = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        $(this._lineView).css({ position: 'absolute' });
        let lineRect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        $(lineRect).attr({
            position: 'absolute',
            width: '100%',
            height: '100%',
            class: 'lineRect',
            fill: 'none',
            stroke: this._lineColor,
            'stroke-width': this._lineWidth,
            'stroke-dasharray': '2, 2',
        });
        let lineRectBack = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        $(lineRectBack).attr({
            position: 'absolute',
            width: '100%',
            height: '100%',
            class: 'lineRectBack',
            fill: 'none',
            stroke: this._lineBackColor,
            'stroke-width': this._lineWidth,
        });
        this._lineView.appendChild(lineRectBack);
        this._lineView.appendChild(lineRect);
        this._trackLayer.appendChild(this._lineView);
    }
    _initNodesView() {
        for (let i = 0; i < 8; i++) {
            let node = document.createElement('div');
            $(node).css({
                position: 'absolute',
                width: 2 * this._trackNodeRadius + 'px',
                height: 2 * this._trackNodeRadius + 'px',
                visibility: 'hidden',
                border: '2px solid #FFFFFF',
            });

            switch (i) {
                case TrackNode.TOP: {
                    $(node).css({
                        left: '50%',
                        top: 0,
                        marginLeft: -8 + 'px',
                        marginTop: -3.5 + 'px',

                        width: '16px',
                        height: '7px',
                        boxShadow: '0px 1px 6px 0px rgba(0, 0, 0, 0.5)',
                        borderRadius: '4px',
                        border: '1px solid rgba(32, 25, 25, 0)',
                    });
                    break;
                }
                case TrackNode.BOTTOM: {
                    $(node).css({
                        left: '50%',
                        bottom: 0,
                        marginLeft: -8 + 'px',
                        marginBottom: -3.5 + 'px',

                        width: '16px',
                        height: '7px',
                        boxShadow: '0px 1px 6px 0px rgba(0, 0, 0, 0.5)',
                        borderRadius: '4px',
                        border: '1px solid rgba(32, 25, 25, 0)',
                    });
                    break;
                }
                case TrackNode.LEFT: {
                    $(node).css({
                        top: '50%',
                        marginTop: -8 + 'px',
                        marginLeft: -3.5 + 'px',

                        width: '7px',
                        height: '16px',
                        boxShadow: '0px 1px 6px 0px rgba(0, 0, 0, 0.5)',
                        borderRadius: '4px',
                        border: '1px solid rgba(32, 25, 25, 0)',
                    });
                    break;
                }
                case TrackNode.RIGHT: {
                    $(node).css({
                        top: '50%',
                        right: 0,
                        marginTop: -8 + 'px',
                        marginRight: -3.5 + 'px',

                        width: '7px',
                        height: '16px',
                        boxShadow: '0px 1px 6px 0px rgba(0, 0, 0, 0.5)',
                        borderRadius: '4px',
                        border: '1px solid rgba(32, 25, 25, 0)',
                    });
                    break;
                }
                case TrackNode.LEFT_TOP: {
                    $(node).css({
                        left: -this._trackNodeRadius + 'px',
                        top: -this._trackNodeRadius + 'px',
                        borderRadius: this._trackNodeRadius + 'px',
                    });
                    break;
                }
                case TrackNode.LEFT_BOTTOM: {
                    $(node).css({
                        left: -this._trackNodeRadius + 'px',
                        bottom: -this._trackNodeRadius + 'px',
                        borderRadius: this._trackNodeRadius + 'px',
                    });
                    break;
                }
                case TrackNode.RIGHT_TOP: {
                    $(node).css({
                        right: -this._trackNodeRadius + 'px',
                        top: -this._trackNodeRadius + 'px',
                        borderRadius: this._trackNodeRadius + 'px',
                    });
                    break;
                }
                case TrackNode.RIGHT_BOTTOM: {
                    $(node).css({
                        right: -this._trackNodeRadius + 'px',
                        bottom: -this._trackNodeRadius + 'px',
                        borderRadius: this._trackNodeRadius + 'px',
                    });
                    break;
                }
                default:
            }

            this._nodeView.push(node);
            this._trackLayer.appendChild(node);
        }

        let rotateNode = document.createElement('div');
        $(rotateNode).css({
            position: 'absolute',
            width: 2 * this._rotateNodeRadius + 'px',
            height: 2 * this._rotateNodeRadius + 'px',
            borderRadius: this._rotateNodeRadius + 'px',
            background: '#ffffff',
            boxShadow: this._trackNodeBoxShadow,
            visibility: 'hidden',
            left: '50%',
            top: `calc(100% + ${this._rotateLength}px)`,
            transform: 'translateX(-50%)',
        });
        this._nodeView.push(rotateNode);
        this._trackLayer.appendChild(rotateNode);
    }
    _initRotateSVG() {
        if (this._hasRotationNode) {
            let rotateNode = this._nodeView[this._nodeView.length - 1];
            this._rotateSVG = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            $(this._rotateSVG).attr({
                width: 22,
                height: 22,
                viewBox: '-1 -1 22 22',
            });
            $(this._rotateSVG).css({
                position: 'absolute',
                left: '50%',
                top: '50%',
                marginLeft: '-11px',
                marginTop: '-11px',
            });

            let path1 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            $(path1).attr({
                fill: FJCoreConfig.trackRotateNormalColor,
                d:
                    'M18.96,8.369c-0.311-0.309-0.854-0.312-1.166,0l-0.887,0.888C16.669,5.657,13.662,2.8,10,2.8\n' +
                    '\t\tc-1.85,0-3.587,0.72-4.892,2.026C4.952,4.981,4.865,5.188,4.865,5.408c0,0.22,0.086,0.426,0.243,0.582\n' +
                    '\t\tc0.312,0.311,0.854,0.31,1.163,0c0.998-0.996,2.322-1.543,3.73-1.543c2.738,0,4.996,2.096,5.252,4.774l-0.851-0.851\n' +
                    '\t\tc-0.31-0.309-0.853-0.312-1.166,0.001c-0.32,0.322-0.319,0.844,0,1.165l2.278,2.277c0.153,0.157,0.36,0.244,0.583,0.244\n' +
                    '\t\tc0.219,0,0.425-0.086,0.581-0.242l2.279-2.279C19.278,9.214,19.279,8.691,18.96,8.369z',
                class: 'path',
            });
            let path2 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            $(path2).attr({
                fill: FJCoreConfig.trackRotateNormalColor,
                d:
                    'M13.729,13.449c-0.994,0.996-2.319,1.544-3.729,1.544c-2.737,0-4.994-2.096-5.249-4.772l0.851,0.85\n' +
                    '\t\tc0.311,0.311,0.849,0.311,1.163,0c0.319-0.321,0.319-0.844,0-1.165L4.487,7.628C4.183,7.319,3.629,7.317,3.32,7.626l-2.28,2.28\n' +
                    '\t\tc-0.319,0.32-0.32,0.843,0,1.166c0.312,0.311,0.854,0.311,1.165,0l0.889-0.891C3.333,13.782,6.339,16.64,10,16.64\n' +
                    '\t\tc1.85,0,3.588-0.72,4.896-2.026c0.319-0.321,0.319-0.844,0-1.164C14.582,13.138,14.039,13.14,13.729,13.449z',
                class: 'path',
            });
            this._rotateSVG.appendChild(path1);
            this._rotateSVG.appendChild(path2);
            rotateNode.appendChild(this._rotateSVG);
        }
    }

    // public
    trackLayer() {
        this._init();
        return this._trackLayer;
    }

    keepAspectRatio() {
        if (typeof arguments[0] === 'undefined') {
            return this._keepAspectRatio;
        } else {
            this._keepAspectRatio = arguments[0];
        }
    }

    setHasRotationNode(value) {
        this._hasRotationNode = value;

        if (!this._nodeView || this._nodeView.length === 0) this._init();
        if (!this._rotateSVG) this._initRotateSVG();
        this._updateRotateVisible();
    }

    setHasNode(value) {
        this._hasNode = value;
    }

    renderRect() {
        const rect = this._getTrackRect();
        if (!rect) {
            return null;
        }
        if (!this._hasNode) {
            return rect;
        }
        // rect.x -= this._trackNodeRadius;
        // rect.y -= this._trackNodeRadius;
        // rect.width += 2 * this._trackNodeRadius;
        // rect.height += 2 * this._trackNodeRadius;
        return rect;
    }

    draw(view, options = {}) {
        const {
            selected,
            trackRect,
            angle,
            opacity = 1,
            isCanRender,
            isJustRenderLine,
            isDottedLine,
            lineStyle = {},
        } = options;
        this._init();

        if (typeof trackRect !== 'undefined') this._trackRect = { ...trackRect };
        if (typeof angle !== 'undefined') this._angle = angle;
        if (typeof selected !== 'undefined') this._selected = selected;
        if (view != null) this._viewRect = { x: 0, y: 0, width: view.offsetWidth, height: view.offsetHeight };
        if (!this.renderRect()) return;

        if (isCanRender) {
            const style = {
                fill: 'none',
                opacity: opacity,
                stroke: this._lineColor,
                'stroke-width': this._lineWidth,
                'stroke-dasharray': '0, 0',
            };
            this._updateDrawLayer(view);
            this._nodes = this._trackNodes();
            if (isJustRenderLine) {
                this._clearAllNodes();
                if (isDottedLine) {
                    const { color, dasharray } = lineStyle;
                    style.stroke = color ? color : 'rgba(255, 255, 255, 1)';
                    style['stroke-dasharray'] = dasharray ? dasharray : '2, 2';
                }
                this._drawLine(isDottedLine, style);
            } else if (this._selected) {
                this._drawLine(false, style);
                this._drawNodes();
            }
        } else {
            this.clear();
        }
    }

    clear() {
        if (this._trackLayer?.parentNode) {
            this._trackLayer.parentNode.removeChild(this._trackLayer);
        }
    }

    trackNodeAtPoint(point) {
        let result = -1;
        if (!point || !point.hasOwnProperty('x') || !point.hasOwnProperty('y')) {
            return result;
        }
        let p = this.convertMousePointToTrack(point);
        for (let i = 0; i < this._nodes.length; i++) {
            let node = this._nodes[i];
            if (this._isInvalidNode(node)) continue;

            if (this._hitTestAtPoint(node.position, p)) {
                result = i;
                if (this._selectedNode !== i) {
                    this._selectedNode = i;
                    if (this._selected) this._drawNodes();
                }
                break;
            }
        }

        if (result !== -1) return result;

        if (this._selectedNode !== -1) {
            this._selectedNode = -1;
            if (this._selected) this._drawNodes();
        }

        // 如果该点不在画布区域内，防止某些超出画布区域的画中画可以被替换
        const pointView = FJArchiveUtil.getAuxiliary();

        if (pointView) {
            const pointViewRect = pointView.getBoundingClientRect();
            const viewRect = {
                x: 0,
                y: 0,
                width: pointViewRect.width,
                height: pointViewRect.height,
            };
            if (!FJMathUtil.isPointInRect(point, viewRect)) {
                return -1;
            }
        }

        let rect = this.renderRect();
        if (rect) {
            rect.x = 0;
            rect.y = 0;
            if (FJMathUtil.isPointInRect(p, rect)) {
                return TrackNode.MOVE;
            }
        }

        return -1;
    }

    updateTrack(selected, trackRect, angle, viewSize) {
        if (trackRect !== null && typeof trackRect !== 'undefined')
            this._trackRect = { x: trackRect.x, y: trackRect.y, width: trackRect.width, height: trackRect.height };
        if (angle !== null && typeof angle !== 'undefined') this._angle = angle;
        if (selected !== null && typeof selected !== 'undefined') this._selected = selected;
        if (viewSize != null) this._viewRect = { x: 0, y: 0, width: viewSize.width, height: viewSize.height };
    }
    getTrackSize() {
        return { width: this._trackRect.width, height: this._trackRect.height };
    }

    // private
    // 对象的大小
    _getTrackRect() {
        if (!this._trackRect) return null;
        return { ...this._trackRect };
    }

    _trackNodes() {
        let rect = this._getTrackRect();
        rect.x = 0;
        rect.y = 0;
        let leftTopNode = { x: rect.x, y: rect.y },
            topNode = { x: rect.x + rect.width / 2, y: rect.y },
            rightTopNode = { x: rect.x + rect.width, y: rect.y },
            rightNode = { x: rect.x + rect.width, y: rect.y + rect.height / 2 },
            rightBottomNode = { x: rect.x + rect.width, y: rect.y + rect.height },
            bottomNode = { x: rect.x + rect.width / 2, y: rect.y + rect.height },
            leftBottomNode = { x: rect.x, y: rect.y + rect.height },
            leftNode = { x: rect.x, y: rect.y + rect.height / 2 };

        let nodes = [
            { position: leftTopNode, type: TrackNode.LEFT_TOP },
            { position: topNode, type: TrackNode.TOP },
            { position: rightTopNode, type: TrackNode.RIGHT_TOP },
            { position: rightNode, type: TrackNode.RIGHT },
            { position: rightBottomNode, type: TrackNode.RIGHT_BOTTOM },
            { position: bottomNode, type: TrackNode.BOTTOM },
            { position: leftBottomNode, type: TrackNode.LEFT_BOTTOM },
            { position: leftNode, type: TrackNode.LEFT },
        ];

        if (this._hasRotationNode) {
            let rotateNode = {
                x: rect.x + rect.width / 2,
                y: rect.height + (this._rotateNodeRadius + this._rotateLength),
            };
            // 旋转点自动适配
            let autoRotateNode = { ...rotateNode };

            rotateNode = autoRotateNode ? autoRotateNode : rotateNode;
            nodes.push({ position: rotateNode, type: TrackNode.ROTATE });
        }
        return nodes;
    }

    /**
     * 更新旋转点位置
     * @param {{}} placement
     * @returns
     */
    _updateRotateDom(placement = 'bottom') {
        let rotateDom = this._nodeView[this._nodeView.length - 1];
        if (!rotateDom) return;

        switch (placement) {
            case 'top': {
                $(rotateDom).css({
                    left: '50%',
                    top: `-${this._rotateLength + this._rotateNodeRadius * 2}px`,
                    transform: 'translateX(-50%)',
                });
                break;
            }
            case 'right': {
                $(rotateDom).css({
                    left: `calc(100% + ${this._rotateLength}px)`,
                    top: '50%',
                    transform: 'translateY(-50%)',
                });
                break;
            }
            case 'left': {
                $(rotateDom).css({
                    left: `-${this._rotateLength + this._rotateNodeRadius * 2}px`,
                    top: '50%',
                    transform: 'translateY(-50%)',
                });
                break;
            }
            case 'bottom': {
                $(rotateDom).css({
                    left: '50%',
                    top: `calc(100% + ${this._rotateLength}px)`,
                    transform: 'translateX(-50%)',
                });
                break;
            }
            default: {
                // 默认在下
                $(rotateDom).css({
                    left: '50%',
                    top: `calc(100% + ${this._rotateLength}px)`,
                    transform: 'translateX(-50%)',
                });
                break;
            }
        }
    }
    _updateRotateVisible() {
        if (!this._nodeView || this._nodeView.length === 0) this._init();
        const rotateNode = this._nodeView[this._nodeView.length - 1];
        rotateNode.style.display = this._hasRotationNode ? 'block' : 'none';
    }

    // 更新layer的位置大小，旋转和添加layer
    _updateDrawLayer(view) {
        let rect = this._getTrackRect();
        if (!rect) return;
        rect = FJMathUtil.integratedRect(rect);
        this._trackLayer.style.left = rect.x + 'px';
        this._trackLayer.style.top = rect.y + 'px';
        this._trackLayer.style.width = rect.width + 'px';
        this._trackLayer.style.height = rect.height + 'px';
        this._trackLayer.style.transform = 'rotate(' + this._angle + 'deg)';
        if (this._selected) this._trackLayer.style.zIndex = 200;
        else this._trackLayer.style.zIndex = 'auto';
        if (view && this._trackLayer.parentNode !== view) {
            view.appendChild(this._trackLayer);
            this._viewRect = { x: 0, y: 0, width: view.offsetWidth, height: view.offsetHeight };
        }
    }
    // 设置颜色
    _updateNormalTrackNodeColor(node, color) {
        $(node).css({
            background: color ? color : FJCoreConfig.trackNodeNormalFillColor,
            boxShadow: this._trackNodeBoxShadow,
            // boxShadow: "0 0 0 1px " + FJCoreConfig.trackNodeNormalStrokeColor + ", 0 0 4px 2px rgba(0,0,0,0.2)"
        });
    }
    _updateSelectedTrackNodeColor(node, color) {
        $(node).css({
            background: color ? color : FJCoreConfig.trackNodeSelectedFillColor,
            boxShadow: this._trackNodeBoxShadow,
            // boxShadow: "0 0 0 1px " + FJCoreConfig.trackNodeSelectedStrokeColor + ", 0 0 4px 2px rgba(0,0,0,0.2)"
        });
    }
    // draw
    _clearAllNodes() {
        for (let i = 0; i < this._nodeView.length; i++) {
            let node = this._nodeView[i];
            node.style.visibility = 'hidden';
        }
    }
    _drawLine(isDottedLine, lineStyle) {
        let rect = this._getTrackRect();
        if (!rect) return;
        rect = FJMathUtil.integratedRect(rect);

        $(this._lineView).attr({ width: rect.width, height: rect.height });
        let lineRect = $(this._lineView).find('.lineRect');
        let lineRectBack = $(this._lineView).find('.lineRectBack');
        $(lineRect).attr(lineStyle);
        $(lineRectBack).attr(lineStyle);
        if (lineRectBack) $(lineRectBack).css({ opacity: isDottedLine ? 0 : 1 });
    }

    // 判断 node 是否无效
    _isInvalidNode(node) {
        let invalidNodesForAspect = [];
        if (this._keepAspectRatio) {
            invalidNodesForAspect = [TrackNode.TOP, TrackNode.BOTTOM, TrackNode.LEFT, TrackNode.RIGHT];
        } else if (this._keepAspectHorizontal) {
            invalidNodesForAspect = [TrackNode.LEFT, TrackNode.RIGHT];
        } else if (this._keepAspectVertical) {
            invalidNodesForAspect = [TrackNode.TOP, TrackNode.BOTTOM];
        }

        if (invalidNodesForAspect.includes(node.type)) {
            return true;
        }

        if (!this._hasRotationNode) {
            return node.type === TrackNode.ROTATE;
        }

        return false;
    }

    _drawNodes() {
        if (!this._hasNode || !this._trackLayer) return;

        for (let i = 0; i < this._nodes.length; i++) {
            let node = this._nodes[i];
            let nodeView = this._nodeView[i];
            if (this._isInvalidNode(node)) {
                $(nodeView).css({
                    visibility: 'hidden',
                });
                continue;
            }
            $(nodeView).css({
                visibility: 'visible',
            });

            if (this._selectedNode === node.type) {
                if (node.type === TrackNode.ROTATE) {
                    $(this._rotateSVG).find('path').css({
                        fill: FJCoreConfig.trackRotateNormalColor,
                    });
                } else {
                    this._updateSelectedTrackNodeColor(nodeView);
                }
            } else {
                if (node.type === TrackNode.ROTATE) {
                    $(this._rotateSVG).find('path').css({
                        fill: FJCoreConfig.trackRotateNormalColor,
                    });
                } else if (
                    node.type === TrackNode.TOP ||
                    node.type === TrackNode.RIGHT ||
                    node.type === TrackNode.BOTTOM ||
                    node.type === TrackNode.LEFT
                ) {
                    this._updateNormalTrackNodeColor(nodeView, FJCoreConfig.trackStretchNormalColor);
                } else {
                    this._updateNormalTrackNodeColor(nodeView);
                }
            }
        }
    }

    // 点的判断
    _hitTestAtPoint(node, p) {
        let x = node.x - (this._trackNodeRadius + 2);
        let y = node.y - (this._trackNodeRadius + 2);
        let w = node.x + (this._trackNodeRadius + 2);
        let h = node.y + (this._trackNodeRadius + 2);
        return x <= p.x && w >= p.x && y <= p.y && h >= p.y && this._hasNode;
    }

    convertMousePointToTrack(p) {
        this._init();
        let trackRect = this._getTrackRect();
        if (!trackRect) return p;
        let centerPoint = {
            x: trackRect.x + trackRect.width / 2,
            y: trackRect.y + trackRect.height / 2,
        };

        let offset = 0;

        let convertPoint = FJMathUtil.convertPointByAngle(p, centerPoint, this._angle);
        return { x: convertPoint.x - trackRect.x + offset, y: convertPoint.y - trackRect.y + offset };
    }
    /**
     * @desc 根据角度得到正确的光标
     * @param angle - 角度
     * @param currentNode - 当前选中的节点
     * @return {*|number}
     */
    static cursorOfAngle(angle, currentNode) {
        let nodeAngle = 0;
        switch (currentNode) {
            case TrackNode.LEFT_TOP:
                nodeAngle = 315;
                break;
            case TrackNode.RIGHT_TOP:
                nodeAngle = 45;
                break;
            case TrackNode.RIGHT_BOTTOM:
                nodeAngle = 135;
                break;
            case TrackNode.LEFT_BOTTOM:
                nodeAngle = 225;
                break;
            case TrackNode.TOP:
                nodeAngle = 0;
                break;
            case TrackNode.BOTTOM:
                nodeAngle = 180;
                break;
            case TrackNode.LEFT:
                nodeAngle = 270;
                break;
            case TrackNode.RIGHT:
                nodeAngle = 90;
                break;
            default:
                return currentNode;
        }

        nodeAngle += angle;
        if (nodeAngle >= 360) nodeAngle -= 360;
        let angleScopes = [
            [337.5, 22.5],
            [22.5, 67.5],
            [67.5, 112.5],
            [112.5, 157.5],
            [157.5, 202.5],
            [202.5, 247.5],
            [247.5, 292.5],
            [292.5, 337.5],
        ];
        let nodes = [
            TrackNode.TOP,
            TrackNode.RIGHT_TOP,
            TrackNode.RIGHT,
            TrackNode.RIGHT_BOTTOM,
            TrackNode.BOTTOM,
            TrackNode.LEFT_BOTTOM,
            TrackNode.LEFT,
            TrackNode.LEFT_TOP,
        ];
        let node;
        for (let i = 0; i < angleScopes.length; i++) {
            let scope = angleScopes[i];
            if (i === 0) {
                if ((nodeAngle >= 0 && nodeAngle <= scope[1]) || (nodeAngle >= scope[0] && nodeAngle <= 360)) {
                    node = nodes[i];
                    break;
                }
            } else if (nodeAngle >= scope[0] && nodeAngle <= scope[1]) {
                node = nodes[i];
                break;
            }
        }

        return node;
    }
}

export default FJTrack;
export { FixNode, TrackNode };
